module.exports = __webpack_public_path__ + "f005526fcc5b0261ea3d9ef3c02d89a6.svg";